var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.buttonsIterator),function(button){return _c('button',{key:button.id,class:'widget-button-right btn ' + button.class,attrs:{"type":"button","disabled":button.disabled},on:{"click":function($event){return _vm.$root.$emit(button.eventName)}}},[_vm._v(" "+_vm._s(button.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }